import { useEffect, useRef } from 'react'

import { useLinkWallet } from '@/data'
import { useWallet } from '@/hooks/use-wallet'
import { isBtcChain } from '@/utils'

export const useLinkBtcWallet = () => {
  const { wallets } = useWallet()
  const { mutate } = useLinkWallet()
  const linkedBtcWallet = useRef(false)

  useEffect(() => {
    const btcWallet = Object.keys(wallets).find(isBtcChain)
    if (!btcWallet || linkedBtcWallet.current) return
    const btcWalletAddresses = wallets[btcWallet]?.wallet?.getAddresses?.() ?? []
    if (btcWalletAddresses.length > 1) {
      mutate({ wallets: btcWalletAddresses })
      linkedBtcWallet.current = true
    }
  }, [wallets])
}
